import useCheckAccess from 'hooks/useCheckAccess';
import React, { useEffect } from 'react';
import { BooleanInput, FormDataConsumer } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';

const RequiredInput = ({ action }: { action: 'create' | 'update' }) => {
  const { setValue } = useFormContext();
  const { required } = useWatch();

  useEffect(() => {
    if (required) {
      setValue('required_for_approval', true);
    }
  }, [required, setValue]);

  const checkAccess = useCheckAccess();
  return (
    <>
      {checkAccess(action, 'QualificationAttribute', 'required') && (
        <BooleanInput source="required" />
      )}
      {checkAccess(action, 'QualificationAttribute', 'required_for_approval') && (
        <FormDataConsumer>
          {({ formData }) => (
            <BooleanInput source="required_for_approval" disabled={formData.required} />
          )}
        </FormDataConsumer>
      )}
    </>
  );
};

export default RequiredInput;
